import logo from 'assets/images/TransUni_logo.png';

// ==============================|| LOGO ||============================== //

export default function Logo({ dark = false }: { dark?: boolean }) {
  return <img src={logo} alt="Trans-Uni" height="42" style={{ filter: dark ? 'brightness(0) invert(1)' : 'none' }} />;
}
